import apiFetch from '../../apiFetch'

export default function (token, order, lastAccessDate) {
  return apiFetch({ endPoint: 'dossier/purchase/reassignPurchaseModal', method: 'PUT', body: order, token: token, lastAccessDate })
}
